import ClickEndSound from "assets/audio/click_end.wav";
import ClickStartSound from "assets/audio/click_start.wav";

/** A blocked autoplay or a missing device just means no click. */
const playSound = async (src: string) => {
  try {
    await new Audio(src).play();
  } catch {
    return;
  }
};

/** Mic is opening — played on the mic click and on a push-to-talk hold. */
export const playDictationStartSound = () => void playSound(ClickStartSound);

/** Dictation is over — played on ✓, ✗ and a push-to-talk release. */
export const playDictationEndSound = () => void playSound(ClickEndSound);
